import { Component } from 'react';
import moment from 'moment';

//configs
import { PROJECT_NAME, SERVER_IS_NORWAY } from '../../../library/config';

class SignatureWrapper extends Component {
    render() {
        const signTitle = PROJECT_NAME || "Time And Control";
        let addHours = SERVER_IS_NORWAY ? 2 : -4;
        let time = moment().utc().add(addHours, 'hours');
        time = time.format('YYYYMMDDhhmmss');
        return (
            <div className="divInlineBlock paddingSign" style={{ visibility: "none", zIndex: -1 }}>
                <div className="signWrap signInlineBorder signResponsive">
                    <span className="signBorderLeft"></span>
                    <span className="signBorderRight"></span>
                    <span className="signTitle">{signTitle}</span>
                    <img className="sign font-15" src={this.props.imgSrc} alt="sign here" style={{ maxWidth: '300px', maxHeight: '300px' }}></img>
                    <span className="signUniqueId">{time}</span>
                </div>
            </div>
        );
    }
}
export default SignatureWrapper;
